import { CheckCircle } from '@mui/icons-material'
import { Grid, Theme, Typography } from '@mui/material'

import usePauseDevice from '../../utils/hooks/usePauseDevice'

import useStyles from './pause-duration.styles'

const PauseDuration = ({ device, timezone }: { device: IDeviceType; timezone?: string }) => {
  const classes = useStyles
  const { isPaused, willBePaused, isPausedIndefinitely, pausedText } = usePauseDevice({ device, timezone })

  return (
    <>
      {(isPaused || isPausedIndefinitely || willBePaused) && (
        <Grid size={12} container={true}>
          <Grid
            container={true}
            sx={(theme: Theme) => ({
              ...classes.container(theme),
              ...(isPaused || isPausedIndefinitely ? classes.pausedContainer : {}),
            })}
          >
            <CheckCircle htmlColor="#47B282" />
            <Typography variant="body1" sx={classes.textContent}>
              {pausedText}
            </Typography>
          </Grid>
        </Grid>
      )}
    </>
  )
}

export default PauseDuration
